import { Controller } from "@hotwired/stimulus"

// Rozwijanie/zwijanie wiersza listy połączeń VoIP - pokazuje panel ze szczegółami
// (odtwarzacz nagrania, notatka, transkrypcja, akcje). Kliknięcie w link/przycisk/menu
// wewnątrz wiersza nie zwija wiersza (nawigacja i akcje działają normalnie).
export default class extends Controller {
  static targets = ["panel", "chevron"]

  toggle(event) {
    // ignoruj kliknięcia w elementy interaktywne - inaczej klik w menu/link zwijałby wiersz
    if (event.target.closest("a, button, audio, input, [data-voip-row-ignore]")) return
    this.panelTarget.classList.toggle("hidden")
    this.chevronTarget.classList.toggle("rotate-90")
  }
}
